<template>
  <v-file-input
    :id="'addModuleResource' + module.id"
    v-model="playlistAttachment"
    :clearable=false
    :rules="rules"
    :disabled="isUpdating || restrictPlaylistAccess"
    dense
    flat
    :color="playlist.default_color"
    accept="image/*, application/pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv"
    placeholder="Add Resource"
    label="PDF, Doc, CSV, or Image"
    ref="playlistUploader"
    @change="handleResourceAdded"
    hide-details="auto"
  ></v-file-input>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  name: 'PlaylistResources',
  props: [
    'module',
  ],
  data: () => ({
    playlistAttachment: null,
    rules: [
      value => !value || value.size < 25000000 || 'File size should be less than 25 MB!',
      value => !value || value.type.includes('image/') || value.type.includes('pdf') || value.name.includes('doc') || 'Only images, PDFs, and documents are allowed!',
    ],
  }),
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'playlist',
      'user',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
  },
  methods: {
    ...mapMutations([
      'toggleSnackbar',
    ]),
    ...mapActions([
      'createAttachment',
      'updatePlaylist',
    ]),
    async handleResourceAdded() {
      try {
        const file = this.playlistAttachment;
        if (this.playlistAttachment) {
          await this.createAttachment({
            file,
            module: this.module,
          });
          this.playlistAttachment = null;
        }
      } catch(e) {
        this.playlistAttachment = null;
        this.toggleSnackbar({
          text: 'Error uploading file.',
          color: 'error',
          timeout: 2500,
        });
      }
    },
    setResourceInputColor() {
      const icon = document.getElementsByClassName('mdi-paperclip')[this.module.order];
      if (icon) icon.style.color = this.playlist.default_color;
    },
  },
  mounted() {
    this.setResourceInputColor();
  },
  watch: {
    'playlist.default_color': function defaultColorWatcher(n) {
      if (n) this.setResourceInputColor();
    },
  },
};
</script>
